import Commons from '../../../Services/Common/Common';

/**
 * 회의록 상세 (M_MET_BASIC_01) 요청 파라미터 매핑
 * 사용처: M_MET_BASIC_01_Query.js (useSearch1~4, useSave1~5)
 */
export const MET_BASIC_01_Schema = {
  mapper: {
    /** useSearch1 → GetMetBasic01R1 (상세 대표) SP_SUB_BASIC_03_R8 */
    search1: {
      Chaebun: (ctx) => Commons.EncryptAES(ctx.chaebun ?? '') || '',
    },
    /** useSearch2 → GetMetBasic01R2 (상세 참석자 C) SP_SUB_BASIC_03_R4 */
    search2: {
      Chaebun: (ctx) => Commons.EncryptAES(ctx.chaebun ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
    /** useSearch3 → GetMetBasic01R3 (상세 참석자 I) SP_SAC_BASIC_R4 */
    search3: {
      Chaebun: (ctx) => Commons.EncryptAES(ctx.chaebun ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
    /** useSearch4 → GetMetBasic01R4 (불참 알림 대상) SP_SUB_BASIC_03_R6 */
    search4: {
      Id: (ctx) => Commons.EncryptAES(ctx.updateId ?? '') || '',
    },
    /** useSave1 → SaveMetBasic01U1 (대표 승인) SP_SUB_BASIC_03_U5 */
    save1: {
      Chaebun: (ctx) => Commons.EncryptAES(ctx.chaebun ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
    /** useSave2 → SaveMetBasic01U2 (참석자 서명 C) SP_SUB_BASIC_03_U4 */
    save2: {
      Chaebun: (ctx) => Commons.EncryptAES(ctx.chaebun ?? '') || '',
      CheckYn: (ctx) => Commons.EncryptAES(ctx.checkYn ?? 'Y') || '',
      FileName: (ctx) => Commons.EncryptAES(ctx.fileName ?? '') || '',
      FilePath: (ctx) => Commons.EncryptAES(ctx.filePath ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
    /** useSave3 → SaveMetBasic01U3 (참석자 서명 I) SP_SAC_BASIC_U6 */
    save3: {
      Chaebun: (ctx) => Commons.EncryptAES(ctx.chaebun ?? '') || '',
      CheckYn: (ctx) => Commons.EncryptAES(ctx.checkYn ?? 'Y') || '',
      FileName: (ctx) => Commons.EncryptAES(ctx.fileName ?? '') || '',
      FilePath: (ctx) => Commons.EncryptAES(ctx.filePath ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
    /** useSave4 → SaveMetBasic01U4 (참석 여부 C) SP_SUB_BASIC_03_U7 */
    save4: {
      Chaebun: (ctx) => Commons.EncryptAES(ctx.chaebun ?? '') || '',
      AttendYn: (ctx) => Commons.EncryptAES(ctx.attendYn ?? '') || '',
      NonAttendReason: (ctx) =>
        Commons.EncryptAES(ctx.nonAttendReason ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
    /** useSave5 → SaveMetBasic01U5 (참석 여부 I) SP_SAC_BASIC_U5 */
    save5: {
      Chaebun: (ctx) => Commons.EncryptAES(ctx.chaebun ?? '') || '',
      AttendYn: (ctx) => Commons.EncryptAES(ctx.attendYn ?? '') || '',
      NonAttendReason: (ctx) =>
        Commons.EncryptAES(ctx.nonAttendReason ?? '') || '',
      UserId: (ctx) => ctx.userInfo?.userid ?? '',
    },
  },
};
